<template>
  <section>
    <!-- breadcrumb -->
    <div class="breadcrumb-top">
      <b-breadcrumb class="">
        <b-breadcrumb-item :to="{ name: 'dashboard' }" >
          <feather-icon
            icon="HomeIcon"
            size="16"
          />
        </b-breadcrumb-item>
        <b-breadcrumb-item>
          {{ $t('AMZ Invoice') }}
        </b-breadcrumb-item>
        <b-breadcrumb-item active >
          {{ $t('Invoice List') }}
        </b-breadcrumb-item>
      </b-breadcrumb>
    </div>

    <!-- first floor -->
    <b-row>
      <b-col lg="3">
        <b-card class="card-browser-states ll-fHei ll-card">
          <b-card-body>
            <flat-pickr
              v-model="time"
              class="form-control ll-fpickr"
              :config="dateConfig"
              @input="onChange"
            />
            <b-input-group class="ll-searchBox">
              <b-input-group-prepend
                is-text
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                v-b-toggle.filterS
                class="ll-outline"
                :style="filterBg">
                <!-- Filter -->
                <svg class="ll-ficon" aria-hidden="true">
                  <use xlink:href="#icon-filter"></use>
                </svg>
              </b-input-group-prepend>
              <b-form-input
                v-model="condition.invoiceNo"
                class="searchInput"
                placeholder="Enter InvoiceNo to search"
                :style="styleVar2"
              />
              <b-input-group-prepend
                is-text
                class="ll-searchBtn"
                :style="{'cursor': loadingList ? 'no-drop' : 'pointer'}"
                :disabled="loadingList"
                @click="searchById">
                <feather-icon
                  icon="SearchIcon"
                  class="mr-25"
                  size="18"
                />
              </b-input-group-prepend>
            </b-input-group>
          </b-card-body>
        </b-card>
        <b-overlay :show="loadingList" rounded="sm">
        <div class="ll-cardHei">
          <template v-if="rows.length > 0">
        <b-card
          v-for="(item, index) in rows"
          :key="index"
          class="card-browser-states ll-card ll-cardList"
          :class="item.invoiceNo == selected ? 'bg-light' : 'bg-white'"
          @click="onDetail(item)"
          v-permission="[158]"
        >
          <b-card-header>
            <span class="ll-tkid">{{ item.invoiceNo }}</span>
            <div>
              <b-badge
                pill
                class="ll-badge"
                variant="light-info"
              >
                <span>{{ item.status }}</span>
              </b-badge>
            </div>
          </b-card-header>
          <b-card-body class="ll-cardBody">
            <span v-show="isTime">{{ item.createdAt }}</span>
            <span class="ll-custom">{{ item.customerName }}</span>
          </b-card-body>
        </b-card>
        </template>
        <div v-else class="ll-cardHei d-flex align-items-center justify-content-center">
          <h2>{{ $t('No order found') }}</h2>
        </div>
        </div>
        <!-- 分页 -->
        <div class="d-flex justify-content-between flex-wrap ll-page">
          <div class="d-flex align-items-center mb-0 mt-1" v-if="false">
            <span class="text-nowrap ">
              Showing 1 to
            </span>
            <b-form-select
              v-model="size"
              :options="pageOptions"
              class="mx-1"
              @input="handlePageChange"
            />
            <span class="text-nowrap"> of {{ totalSize }} entries </span>
          </div>
          <div class="d-flex align-items-center mb-0 mt-1 mr-1">
            <span class="text-nowrap ">
              Showing 1 to
            </span>
            <b-form-select
              v-model="size"
              :options="pageOptions"
              class="mx-1"
              @input="handlePageChange"
            />
            <b-pagination
              v-model="page"
              :total-rows="totalSize"
              :per-page="size"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
              @change="handleChangePage"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
            <span class="ll-text text-nowrap">total {{ totalSize }} entries </span>
          </div>
        </div>
        </b-overlay>
      </b-col>
      <b-col lg="9">
        <b-card class="card-browser-states ll-rightCard">
          <b-card-body>
            <b-tabs
              pills
              class="ll-tabs"
              v-permission="[160]"
              v-if="selectedItem"
            >
              <!-- Tab: Overview -->
              <b-tab active>
                <template #title>
                  <span class="d-none d-sm-inline">{{ $t('Overview') }}</span>
                </template>
                <overview :heiVal="heiVal" :invoiceNo="invoiceNo" :id="id"></overview>
              </b-tab>

              <!-- Tab: Item -->
              <b-tab>
                <template #title>
                  <span class="d-none d-sm-inline">{{ $t('Item') }}</span>
                </template>
                <order-list :heiVal="heiVal" :invoiceNo="invoiceNo"></order-list>
              </b-tab>
            </b-tabs>
            <div class="display-4 ll-cardHei d-flex align-items-center justify-content-center" v-else>
              {{ $t('Please select an order to view') }}
            </div>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <!-- Filters sidebar -->
    <b-sidebar id="filterS" title=""
      right
      shadow
      bg-variant="white"
      backdrop>
      <div class="px-3">
        <app-collapse class="ll-collapse">
          <app-collapse-item :title="$t('Status')">
            <v-select
              id="status"
              :options="statusList"
              @input="selStatus"
              v-model="status"
              placeholder="Please Select Status"
            ></v-select>
          </app-collapse-item>
        </app-collapse>
        <div class="ll-btn">
          <b-button
            variant="secondary"
            class="mr-1"
            @click="onClear"
          >
            {{ $t('Clear') }}
          </b-button>
          <b-button variant="info"
            v-b-toggle.filterS
            @click="queryList">
            {{ $t('Search') }}
          </b-button>
        </div>
      </div>
    </b-sidebar>
  </section>
</template>

<script>
import {
  BBreadcrumb, BBreadcrumbItem, BFormTextarea,
  BRow, BCol, BCard, BFormGroup, BFormInput, BBadge, BTable,
  BButton, BSidebar, BInputGroupPrepend, BInputGroup,
  BCardHeader, BCardTitle, BCardBody, VBToggle, BTab, BTabs,
  BPagination, BFormSelect, BAvatar, BOverlay,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import flatPickr from 'vue-flatpickr-component'
import '@core/scss/vue/libs/vue-flatpicker.scss'
import vSelect from 'vue-select'
import { debounce } from "@/libs/fun.js"
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import overview from './components/overview.vue'
import orderList from './components/orderList.vue'
import permission from '@core/directives/permission/index.js'

export default {
  components: {
    overview,
    orderList,
    BBreadcrumb,
    BBreadcrumbItem,
    BRow,
    BCol,
    BCard,
    BFormGroup,
    BFormInput,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BBadge,
    BButton,
    BTable,
    flatPickr,
    BSidebar,
    vSelect,
    BInputGroupPrepend,
    BInputGroup,
    vSelect,
    BFormTextarea,
    BTab,
    BTabs,
    BPagination,
    BFormSelect,
    BAvatar,
    AppCollapse,
    AppCollapseItem,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    BOverlay,
  },
  directives: {
    'b-toggle': VBToggle,
    Ripple,
    permission,
  },
  data() {
    return {
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      pageOptions: [50, 100, 200],
      page: null, // 当前页码
      size: 100, // 每页个数
      totalSize: null, // 总个数
      totalPage: null, // 总页数
      columns: [
        { key: 'invoiceNo', label: 'Invoice No', sortable: true },
        { key: 'status', label: 'Status', sortable: true },
        { key: 'createdAt', label: 'Invoice Date', sortable: true },
        // { key: 'createdAt', label: 'Invoice Type', sortable: true },
        { key: 'orgID', label: 'Bill To Account', sortable: true },
        { key: 'quantity', label: 'Quantity', sortable: true },
        { key: 'totalAmount', label: 'Total Amount', sortable: true },
        { key: 'action', label: 'Action', class: 'll-action' },
      ],
      rows: [],
      searchTerm: '',
      statusList: ['Pending to issue', 'Invoice', 'Cancelled'],
      typeList: ['all', 'LMD', 'CUS', 'MIS'],
      formTime: '',
      toTime: '',
      condition: {
        page: '1',
        size: '100',
        orderBy: 'id',
        orderMole: 1,
        invoiceNo: '',
        status: null,
        beginDate: '',
        endDate: '',
      },
      status: null,
      beginDate: '',
      endDate: '',
      filterBg: {
        '--background': '#fff'
      },
      windowWidth: document.documentElement.clientWidth,  //屏幕宽度
      windowHeight: document.documentElement.clientHeight,   //屏幕高度
      height: document.documentElement.clientHeight*0.67,
      height1: document.documentElement.clientHeight*0.8,
      hei: (document.documentElement.clientHeight*0.67-46)/10,
      heiVal: null,
      hei1: document.documentElement.clientHeight*0.12,
      time: '',
      isTime: true,
      dateConfig: {
        mode: 'range',
        defaultDate: [(new Date).setDate((new Date).getDate() - 2), new Date()],
      },
      selected: '',
      invoiceNo: null,
      id: null,
      loadingList: true,
      selectedItem: null,
    }
  },
  computed: {
    styleVar() {
      return {
        '--cardbody-height': this.hei + 'px'
      }
    },
    styleVar1() {
      return {
        '--height': this.hei1 + 'px'
      }
    },
    styleVar2() {
      return {
        '--height1': this.isDate + 'px'
      }
    },
  },
  watch: {
    windowHeight(val) {
      // console.log(val, this.windowHeight)
      this.height = val*0.67
      this.height1 = val*0.8
      this.hei = (val*0.67-46)/10
      this.heiVal = val*0.67
      this.hei1 = val*0.12
      if (this.hei < 50) {
        this.isTime = false
      } else {
        this.isTime = true
      }
      if (this.hei1 < 102) {
        this.isDate = 40
      } else {
        this.isDate = 59
      }
    },
    windowWidth(val) {
      // console.log('width', val)
    },
    'condition.latestOrderStatus'(val) {
      this.setBg(val)
    },
    'condition.tags'(val) {
      this.setBg(val)
    },
    'condition.serviceParty'(val) {
      this.setBg(val)
    },
  },
  created() {},
  mounted() {
    this.getList()
    // this.configTags()
    // this.querySparty()
    window.onresize = () => {
      return (() => {
        window.fullHeight = document.documentElement.clientHeight
        window.fullWidth = document.documentElement.clientWidth
        this.windowHeight = window.fullHeight
        this.windowWidth = window.fullWidth
      })()
    }
  },
  methods: {
    // filter图标背景颜色设置
    setBg(val) {
      if (val !== null) {
        this.filterBg= {
          '--background': '#ff9f43'
        }
      } else {
        this.filterBg= {
          '--background': '#fff'
        }
      }
    },
    // 默认日期格式转换
    dateFormats() {
      const toDate = new Date((new Date).setDate((new Date).getDate() - 2))
      let datetime1 = toDate.getFullYear() + "-" +
      (toDate.getMonth()> 8 ? (toDate.getMonth() + 1) : "0" + (toDate.getMonth() + 1)) + "-"
      + (toDate.getDate()> 9 ? (toDate.getDate()) : "0" + (toDate.getDate()))
      + ' ' + '00:00:00'

      const fromDate = new Date()
      let datetime = fromDate.getFullYear() + "-" +
      (fromDate.getMonth()> 8 ? (fromDate.getMonth() + 1) : "0" + (fromDate.getMonth() + 1)) + "-"
      + (fromDate.getDate()> 9 ? (fromDate.getDate()) : "0" + (fromDate.getDate()))
      + ' ' + '23:59:59'

      this.condition.beginDate = datetime1
      this.condition.endDate = datetime
    },
    // 查询列表
    queryList() {
      this.$http.post('invoices/list', this.condition).then(res => {
        const info = res.data.data
        this.rows = info.content
        this.page = info.page
        this.size = info.size
        this.totalSize = info.totalSize
        this.totalPage = info.totalPage
        this.loadingList = false
      }).catch(error => console.log(error))
    },
    // 首次查询
    getList() {
      this.dateConfig.dateFormat = 'Y-m-d'
      this.dateFormats()
      this.queryList()
    },
    // 根据日期查询
    onChange: debounce(function() {
      // this.dateConfig.dateFormat = 'Y-m-d H:i:ss'
      const dd = this.time.split('to ')
      if (dd[0] !== '') {
        this.condition.beginDate = (dd[1] !== undefined)? (dd[0] + '00:00:00') : (dd[0] + ' 00:00:00')
        this.condition.endDate = ((dd[1] !== undefined)? dd[1] : dd[0])  + ' 23:59:59'
      } else {
        this.condition.beginDate = null
        this.condition.endDate = null
      }
      this.queryList()
    }, 1000),
    // 根据ID查询
    searchById() {
      this.condition.invoiceNo = this.condition.invoiceNo.trim()
      this.queryList()
    },
    handleChangePage(page) {
      this.condition.page = page
      this.queryList()
    },
    handlePageChange(active) {
      this.condition.size = active
      this.queryList()
    },
    onClear() {
    },
    // 点击查看详情
    onDetail(obj) {
      if (obj) {
        this.selected = obj.invoiceNo
        this.invoiceNo = obj.invoiceNo
        this.id = obj.id
        this.selectedItem = obj
      } else {
        this.selected = ''
        this.invoiceNo = ''
        this.id = id
        this.selectedItem = null
      }
    },
    selType(t) {
      // console.log(t)
      this.condition.invoiceType = t.invoiceType
    },
    selStatus(t) {
      // console.log(t)
      this.condition.status = t.value
      this.status = t.name
    },
  },
}
</script>
<style scoped>
.ll-rightCard{
  height: 76vh;
}
@media (min-width: 2000px) {
  .ll-rightCard {
    height: 82vh;
  }
}
.ll-badge{
  /* padding: 2px; */
  margin-right: 2px;
}
.ll-searchBtn div{
  background-color: #ff9f43;
  color: #fff;
  width: 60px;
  display: flex;
  justify-content: center;
  border-top-right-radius: 5px !important;
  border-bottom-right-radius: 5px !important;
}
.ll-fHei{
  height: 124px;
  margin-bottom: 10px;
}
.icon{
  width: 3em;
  height: 3em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
.ll-conBox{
  display: flex;
  align-items: center;
}
.ll-box{
  margin-left: 10px;
}
.ll-box span{
  display: block;
  text-align: center;
}
.ll-box .ll-tit{
  font-size: 16px;
  font-weight: bold;
}
.ll-searchBox{
  margin-top: 10px;
}
.ll-fHei>.card-body{
  display: flex;
  align-items: center;
}
.ll-cardBody{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.ll-card>.card-body{
  padding: 0;
  /* height: 70px; */
}
.ll-tabs .nav-pills .nav-link.active{
  background-color: unset;
  color: #5e5873;
  box-shadow: none;
  border: none;
  border-bottom: 3px solid #ed6d01;
  border-radius: 0px;
}
.ll-tabs .nav-item{
  font-weight: bold;
}
.ll-btn{
  position: fixed;
  bottom: 10px;
  display: flex;
  justify-content: space-between;
  padding-right: 6rem;
  width: 100%;
}
.ll-tkid{
  color: #161d31;
}
.ll-cardList{
  margin-bottom: 5px;
  cursor: pointer;
}
.ll-cardList .card-header{
  padding: 0.5rem;
}
.ll-cardList .ll-cardBody{
  padding: 0.5rem;
}
.ll-cardHei{
  height: 62vh;
  overflow-y: auto;
}
@media (min-width: 2000px) {
  .ll-cardHei {
    height: 72vh;
  }
}
.ll-cardHei1>.card-body{
  padding: 0;
}
/* .ll-page{
  position: absolute;
  bottom: -10px;
  left: 15%;
} */
.ll-cardActive{
  background: #f6f6f6;
}
.ll-backg{
  background: #f6f6f6;
}
.searchInput{
  height: var(--height1);
}
.ll-0+ div{
  display: none;
}
.ll-outline> div{
  background: var(--background);
}
.ll-custom{
  padding: 0 10px;
}
</style>
<style>
.ll-tabs .nav-item{
  font-weight: bold;
}
.ll-collapse .card{
  box-shadow: none;
}
.ll-text{
  margin: auto;
}
[dir=ltr] .b-sidebar.b-sidebar-right{
  width: 28%;
}
</style>